import ModalWithForm, { type ModalWithFormProps } from './ModalWithForm';

export default ModalWithForm;
export type { ModalWithFormProps };
